import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class CreatedByName extends Field {
  static subqueriesForModel() {
    return { createdByUser: ['name'] };
  }

  get title() {
    return 'Created by name';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Created by user' };
  }

  contentsForRecord(record): FieldContentsData {
    return { text: record.createdByUser?.name };
  }
}
